<template>
  <section class="more-troubleshooting" v-if="posts.length">
    <h2>More Troubleshooting Tips</h2>
    <div class="more-troubleshooting__grid">
      <router-link
        v-for="post in posts"
        :key="post.path"
        :to="post.path"
        class="more-troubleshooting__card"
      >
        <span class="more-troubleshooting__date">{{ post.date }}</span>
        <h3>{{ post.title }}</h3>
        <p>{{ post.desc }}</p>
        <span class="more-troubleshooting__link">Read More</span>
      </router-link>
    </div>
  </section>
</template>

<script>
import { troubleshootingPosts } from '@/documents/blogs.js';

export default {
  name: 'MoreTroubleshootingTips',
  props: {
    limit: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    posts() {
      const currentPath = this.normalizePath(this.$route && this.$route.path);

      return troubleshootingPosts
        .filter((post) => post.published === true && this.normalizePath(post.path) !== currentPath)
        .slice()
        .sort((a, b) => {
          const left = a.publishedAt || a.date || '';
          const right = b.publishedAt || b.date || '';
          return String(right).localeCompare(String(left));
        })
        .slice(0, this.limit);
    },
  },
  methods: {
    normalizePath(path) {
      return path && path.endsWith('/') ? path : `${path || ''}/`;
    },
  },
};
</script>

<style scoped lang="scss">
.more-troubleshooting {
  margin-top: 2.5rem;
  padding-top: 1.75rem;
  border-top: 1px solid #e6ebe8;
}

.more-troubleshooting h2 {
  margin-top: 0;
}

.more-troubleshooting__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-top: 1rem;
}

.more-troubleshooting__card {
  display: flex;
  min-width: 0;
  min-height: 210px;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #dfece4;
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  box-shadow: 0 8px 20px rgba(18, 76, 43, 0.06);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}

.more-troubleshooting__card:hover,
.more-troubleshooting__card:focus-visible {
  border-color: #bfe5cb;
  box-shadow: 0 12px 26px rgba(18, 76, 43, 0.1);
  text-decoration: none;
  transform: translateY(-2px);
}

.more-troubleshooting__date {
  margin-bottom: 8px;
  color: #667085;
  font-size: 0.82rem;
  line-height: 1.4;
}

.more-troubleshooting__card h3 {
  margin: 0 0 10px;
  color: #121820;
  font-size: 1rem;
  line-height: 1.35;
}

.more-troubleshooting__card p {
  display: -webkit-box;
  margin: 0 0 14px;
  overflow: hidden;
  color: #4b5563;
  font-size: 0.9rem;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.more-troubleshooting__link {
  margin-top: auto;
  color: #0b7a3a;
  font-size: 0.9rem;
  font-weight: 700;
}

@media (max-width: 780px) {
  .more-troubleshooting__grid {
    grid-template-columns: 1fr;
  }

  .more-troubleshooting__card {
    min-height: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .more-troubleshooting__card {
    transition: none;
  }

  .more-troubleshooting__card:hover,
  .more-troubleshooting__card:focus-visible {
    transform: none;
  }
}
</style>
